import { ROUTES } from "@pyqml/shared";
import { h, Fragment, ComponentChildren } from "preact"; /** @jsx h */


export type IFooterProps = {
    name: string;

};

export const Footer = (props: IFooterProps) => {

    return (
        <div className="container mt-5">
            <footer className="bg-white border-top p-3 text-muted small">
            <div className="row align-items-center justify-content-between">
                <div>
                    <span className="navbar-brand mr-2"><strong>{props.name}</strong></span> Copyright &copy;
                    { new Date().getFullYear() }
                    . All rights reserved.
                </div>
                <div>
                    <a className="text-secondary font-weight-bold" href={ROUTES.BLOG_PRIVACY}>Privacy</a>
                    <Fragment> | </Fragment>
                    <a className="text-secondary font-weight-bold" href={ROUTES.BLOG_ABOUT}>About</a>
                    
                    {/* 
                    <a target="_blank" className="text-secondary font-weight-bold" href="https://www.wowthemes.net/mundana-free-html-bootstrap-template/">Imprint</a>
                    <Fragment> | </Fragment>
                    <a target="_blank" className="text-secondary font-weight-bold" href="https://www.wowthemes.net/mundana-free-html-bootstrap-template/">Disclaimer</a>
                    */}
                </div>
            </div>
            </footer>
        </div>

    );
}
  
